import { RANGE_FILTER_VALUES } from 'shared/consts/filter'
import { TSelectOption } from 'shared/types'

export const RANGE_FILTER_OPTIONS: TSelectOption[] = [
  {
    label: 'All to date',
    value: ''
  },
  {
    label: 'Last 24 hours',
    value: RANGE_FILTER_VALUES.LAST_DAY
  },
  {
    label: 'This week to date',
    value: RANGE_FILTER_VALUES.THIS_WEEK
  },
  {
    label: 'Last full week',
    value: RANGE_FILTER_VALUES.FULL_WEEK
  }
]